export default {
  SET_ACTIVE_MENU (state, what) {
    state.activeMenu = what
  },
  TOGGLE_MAIN_NAV_STATUS (state, bool) {
    state.mainNavStatus = !state.mainNavStatus
    document.body.classList.toggle('navbar-visible')
  },
  // Track Characteristics
  SET_TRACK_COLOR (state, val) {
    state.trackColor = val
  },
  SET_TRACK_WIDTH (state, int) {
    state.trackWidth = int
  },
  /**
   * Modify the track's opacity
   * @param {string} state The VueX state
   * @param {number} float The opcaity value between 0 and 1
   */
  SET_TRACK_OPACITY (state, float) {
    state.trackOpacity = float
  }
}
